module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/teckensprak_100x56-d387132a537ea8bc137a3bbe772be086.jpg";